import { ChainId } from 'vvs-sdk'
import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens()
// FIXME update pid, address and tokens for LP

export const mainnetFarms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'VVS',
    lpAddresses: {
      338: '0x904Bd5a5AAC0B9d88A0D47864724218986Ad4a3a',
      25: '0x2D03bECE6747ADC00E1a131BBA1469C15fD11e03',
    },
    token: serializedTokens.workbench,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  // {
  //   pid: 251,
  //   lpSymbol: 'CAKE-BNB LP',
  //   lpAddresses: {
  //     338: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
  //     25: '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0',
  //   },
  //   token: serializedTokens.cake,
  //   quoteToken: serializedTokens.wbnb,
  // },
  // {
  //   pid: 252,
  //   lpSymbol: 'BUSD-BNB LP',
  //   lpAddresses: {
  //     338: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
  //     25: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
  //   },
  //   token: serializedTokens.busd,
  //   quoteToken: serializedTokens.wbnb,
  // },
  {
    pid: 1,
    lpSymbol: 'CRO-ETH LP',
    lpAddresses: {
      338: '0xD37d267B2161035A9CF2023F9753CddbfC8B90F3',
      25: '0xA111C17f8B8303280d3EB01BBcd61000AA7F39F9',
    },
    token: serializedTokens.eth,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 2,
    lpSymbol: 'CRO-WBTC LP',
    lpAddresses: {
      338: '0xbDAA80e9EA59bFD3A8AE5705c66804F2e1D9D508',
      25: '0x8F09fFf247B8fDB80461E5Cf5E82dD1aE2EBd6d7',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 3,
    lpSymbol: 'CRO-USDC LP',
    lpAddresses: {
      338: '0x5323D7CE6a12282c0448d255d8B5EDc9918E52Da',
      25: '0xe61Db569E231B3f5530168Aa2C9D50246525b6d6',
    },
    token: serializedTokens.usdc,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 4,
    lpSymbol: 'CRO-VVS LP',
    lpAddresses: {
      338: '0x3F3465b412B6017E20AF7ABFFAB67698de8cFa7a',
      25: '0xbf62c67eA509E86F07c8c69d0286C0636C50270b',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 5,
    lpSymbol: 'VVS-USDC LP',
    lpAddresses: {
      338: '0x9e3A0434ED428dFDe5ace779ead35e141DD95eFf',
      25: '0x814920d1b8007207db6cb5a2dd92bf0b082bdba1',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdc,
    version: 1,
  },
  {
    pid: 6,
    lpSymbol: 'USDC-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x39cC0E14795A8e6e9D02A21091b81FE0d61D82f9',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.usdc,
    version: 1,
  },
  {
    pid: 7,
    lpSymbol: 'VVS-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x280aCAD550B2d3Ba63C8cbff51b503Ea41a1c61B',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdt,
    version: 1,
  },
  {
    pid: 8,
    lpSymbol: 'CRO-SHIB LP',
    lpAddresses: {
      338: '',
      25: '0xc9eA98736dbC94FAA91AbF9F4aD1eb41e7fb40f4',
    },
    token: serializedTokens.shib,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 9,
    lpSymbol: 'CRO-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x3d2180DB9E1B909f35C398BC39EF36108C0FC8c3',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 10,
    lpSymbol: 'CRO-DAI LP',
    lpAddresses: {
      338: '',
      25: '0x3Eb9FF92e19b73235A393000C176c8bb150F1B20',
    },
    token: serializedTokens.dai,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 11,
    lpSymbol: 'CRO-BIFI LP',
    lpAddresses: {
      338: '',
      25: '0x1803E360393A472beC6E1A688BDF7048d3076b1A',
    },
    token: serializedTokens.bifi,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: true,
  },
  {
    pid: 12,
    lpSymbol: 'CRO-DOGE LP',
    lpAddresses: {
      338: '',
      25: '0x2A560f2312CB56327AD5D65a03F1bfEC10b62075',
    },
    token: serializedTokens.doge,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 13,
    lpSymbol: 'CRO-ATOM LP',
    lpAddresses: {
      338: '',
      25: '0x9e5bd780dff875Dd85848a65549791445AE25De0',
    },
    token: serializedTokens.atom,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 14,
    lpSymbol: 'TONIC-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x2f12D47Fe49B907d7a5Df8159C1CE665187F15c4',
    },
    token: serializedTokens.tonic,
    quoteToken: serializedTokens.usdc,
    version: 1,
    isFinished: true,
  },
  {
    pid: 15,
    lpSymbol: 'CRO-ELON LP',
    lpAddresses: {
      338: '',
      25: '0x7AaF2e3AFde06A7f9E686c1dDE4fAB14979384ce',
    },
    token: serializedTokens.elon,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 16,
    lpSymbol: 'CRO-TONIC LP',
    lpAddresses: {
      338: '',
      25: '0x4B377121d968Bf7a62D51B96523d59506e7c2BF0',
    },
    token: serializedTokens.tonic,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 17,
    lpSymbol: 'SINGLE-VVS LP',
    lpAddresses: {
      338: '',
      25: '0x6f72a3f6dB6F486B50217f6e721f4388994B1FBe',
    },
    token: serializedTokens.single,
    quoteToken: serializedTokens.vvs,
    version: 1,
  },
  {
    pid: 18,
    lpSymbol: 'SINGLE-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x0fBAB8A90CAC61b481530AAd3a64fE17B322C25d',
    },
    token: serializedTokens.single,
    quoteToken: serializedTokens.usdc,
    version: 1,
  },
  {
    pid: 19,
    lpSymbol: 'VVS-TONIC LP',
    lpAddresses: {
      338: '',
      25: '0xA922530960A1F94828A7E132EC1BA95717ED1eab',
    },
    token: serializedTokens.tonic,
    quoteToken: serializedTokens.vvs,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x5C78a8dEAd748Ccfa3D1e70E72854D0CaB2eeAd0',
        },
        token: serializedTokens.tonic,
      },
    ],
  },
  {
    pid: 20,
    lpSymbol: 'TUSD-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x94fd83482016bcc5fca5972a3635aa6524c3f557',
    },
    token: serializedTokens.tusd,
    quoteToken: serializedTokens.usdc,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x3AD05dc5Ca8407c0C8386F505e482Ec7ed6DE015',
        },
        token: serializedTokens.tusd,
      },
    ],
  },
  {
    pid: 21,
    lpSymbol: 'CRO-APE LP',
    lpAddresses: {
      338: '',
      25: '0x2eA92065D2c2908bB3C7d6BB9318aF4F8d735dD5',
    },
    token: serializedTokens.ape,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 22,
    lpSymbol: 'CRO-ALI LP',
    lpAddresses: {
      338: '',
      25: '0x78082d9Dee5FDD53dF3b16292077Ee2F6D31F7DE',
    },
    token: serializedTokens.ali,
    quoteToken: serializedTokens.wcro,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x041e27fC23BD30687C798767Cd2222CC8937b1fF',
        },
        token: serializedTokens.ali,
      },
    ],
  },
  {
    pid: 24,
    lpSymbol: 'CRO-DARK LP',
    lpAddresses: {
      338: '',
      25: '0x9284134f3D268CDf0Ef2305c9F06767E913A7CE6',
    },
    token: serializedTokens.dark,
    quoteToken: serializedTokens.wcro,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x818692dce30CF6fe47a4AEaa1517bD934B52C7d3',
        },
        token: serializedTokens.dark,
      },
    ],
    isFinished: true,
  },
  {
    pid: 25,
    lpSymbol: 'CRO-SKY LP',
    lpAddresses: {
      338: '',
      25: '0x542b3bA420581b69212F406e0643Da75fA109b79',
    },
    token: serializedTokens.sky,
    quoteToken: serializedTokens.wcro,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xa2D38F5884deaF87254B43F47Ed89D88B5A87482',
        },
        token: serializedTokens.sky,
      },
    ],
  },
  {
    pid: 26,
    lpSymbol: 'CRO-NESS LP',
    lpAddresses: {
      338: '',
      25: '0xD9DEBAab797Cb92C257B2988AaFA92C728B124E6',
    },
    token: serializedTokens.ness,
    quoteToken: serializedTokens.wcro,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x24C840E3d4c346C912DA09967D300E3DdE851BE1',
        },
        token: serializedTokens.ness,
      },
    ],
    isFinished: true,
  },
  {
    pid: 27,
    lpSymbol: 'VVS-V3S LP',
    lpAddresses: {
      338: '',
      25: '0x57b975364140e4a8d1C96FAa00225b855BaB0E8E',
    },
    token: serializedTokens.v3s,
    quoteToken: serializedTokens.vvs,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x81C17eBbaF467A65B1C085dBd7278b3C05D57cdA',
        },
        token: serializedTokens.vshare,
      },
    ],
    isFinished: true,
  },
  {
    pid: 28,
    lpSymbol: 'CRO-VSHARE LP',
    lpAddresses: {
      338: '',
      25: '0xcb0704BC4E885384ac96F0ED22B9204C3adD91AD',
    },
    token: serializedTokens.vshare,
    quoteToken: serializedTokens.wcro,
    version: 2,
    isFinished: true,
  },
  {
    pid: 29,
    lpSymbol: 'CRO-AKT LP',
    lpAddresses: {
      338: '',
      25: '0x3daff925e2e392Efe499610e56E3Cc2053e85a86',
    },
    token: serializedTokens.akt,
    quoteToken: serializedTokens.wcro,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x1ea16ae1F08E792c804e6E1060224ae209C341eC',
        },
        token: serializedTokens.akt,
      },
    ],
  },
  {
    pid: 30,
    lpSymbol: 'VVS-VERSA LP',
    lpAddresses: {
      338: '',
      25: '0xD7F3d8035cd7BD5aD5E43Fa4E1d4DcA12e133FdD',
    },
    token: serializedTokens.versa,
    quoteToken: serializedTokens.vvs,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x27d8fEa87107D6b28F1B9108889CF7456B7e4725',
        },
        token: serializedTokens.versa,
      },
    ],
  },
  {
    pid: 31,
    lpSymbol: 'VVS-ARGO LP',
    lpAddresses: {
      338: '',
      25: '0x89b330F8E31a1238b667080a0a6e4e5c4C15f7eE',
    },
    token: serializedTokens.argo,
    quoteToken: serializedTokens.vvs,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x4782BB48C4ceD542Db0dfdfFCa72ce7631C9f461',
        },
        token: serializedTokens.argo,
      },
    ],
    startFrom: '2022-04-29T15:00:00.000Z',
  },
  {
    pid: 32,
    lpSymbol: 'ARGO-USDC LP',
    lpAddresses: {
      338: '',
      25: '0xDcBe2035a7b24f7AA479BFf3cCA46d2F5f014B74',
    },
    token: serializedTokens.argo,
    quoteToken: serializedTokens.usdc,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x4782BB48C4ceD542Db0dfdfFCa72ce7631C9f461',
        },
        token: serializedTokens.argo,
      },
    ],
    startFrom: '2022-04-29T15:00:00.000Z',
  },
  // 20220519 hide BUSD/USDC farm
  // {
  //   pid: 33,
  //   lpSymbol: 'BUSD-USDC LP',
  //   lpAddresses: {
  //     338: '',
  //     25: '0x792Df67276615d6E85e36497c4514b7b102Af4A9',
  //   },
  //   token: serializedTokens.busd,
  //   quoteToken: serializedTokens.usdc,
  //   version: 2,
  //   startFrom: '2022-05-20T09:00:00.000Z',
  // },
]

const testnetFarms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'VVS',
    lpAddresses: {
      338: '0x904Bd5a5AAC0B9d88A0D47864724218986Ad4a3a',
      25: '',
    },
    token: serializedTokens.workbench,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 1,
    lpSymbol: 'CRO-ETH LP',
    lpAddresses: {
      338: '0xD37d267B2161035A9CF2023F9753CddbfC8B90F3',
      25: '',
    },
    token: serializedTokens.eth,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 2,
    lpSymbol: 'CRO-WBTC LP',
    lpAddresses: {
      338: '0xbDAA80e9EA59bFD3A8AE5705c66804F2e1D9D508',
      25: '',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 3,
    lpSymbol: 'CRO-VVS LP',
    lpAddresses: {
      338: '0x3F3465b412B6017E20AF7ABFFAB67698de8cFa7a',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  // deprecated
  // {
  //   pid: 4,
  //   lpSymbol: 'CRO-USDC LP',
  //   lpAddresses: {
  //     338: '0x5323D7CE6a12282c0448d255d8B5EDc9918E52Da',
  //     25: '',
  //   },
  //   token: serializedTokens.usdc,
  //   quoteToken: serializedTokens.wcro,
  // },
  {
    pid: 5,
    lpSymbol: 'VVS-USDC LP',
    lpAddresses: {
      338: '0x9e3A0434ED428dFDe5ace779ead35e141DD95eFf',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdc,
    version: 1,
  },
  {
    pid: 6,
    lpSymbol: 'CRO-USDC LP',
    lpAddresses: {
      338: '0xaC7901EFB1F279a18e3f1973664cF4057DdbF0d9',
      25: '',
    },
    token: serializedTokens.usdc,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 7,
    lpSymbol: 'USDC-USDT LP',
    lpAddresses: {
      338: '0xFd8e08cEEA14eC83277518ec892A7f17CB04a06a',
      25: '',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.usdc,
    version: 1,
  },
  {
    pid: 8,
    lpSymbol: 'VVS-USDT LP',
    lpAddresses: {
      338: '0x21D3283f9519D99Ca598a68DC23F286e244Df820',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdt,
    version: 1,
  },
  {
    pid: 9,
    lpSymbol: 'CRO-SHIB LP',
    lpAddresses: {
      338: '0x502494fa12459568c2f57bE01636b0724cc95190',
      25: '',
    },
    token: serializedTokens.shib,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: true,
  },
  // {
  //   pid: 10,
  //   lpSymbol: 'VVS-PIZZA LP',
  //   lpAddresses: {
  //     338: '0x502494fa12459568c2f57bE01636b0724cc95190',
  //     25: '',
  //   },
  //   token: serializedTokens.pizza,
  //   quoteToken: serializedTokens.vvs,
  // },
  // {
  //   pid: 11,
  //   lpSymbol: 'USDC-PIZZA LP',
  //   lpAddresses: {
  //     338: '0x555302ED60Fd293A79C6bA0d05e8711a53c9a7Ce',
  //     25: '',
  //   },
  //   token: serializedTokens.pizza,
  //   quoteToken: serializedTokens.usdc,
  // },
  {
    pid: 12,
    lpSymbol: 'CRO-PIZZA LP',
    lpAddresses: {
      338: '0x65741A08Ecfa072A92862c2822Ffa3f83b3c10F9',
      25: '',
    },
    token: serializedTokens.pizza,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 14,
    lpSymbol: 'CRO-MUFFIN LP',
    lpAddresses: {
      338: '0x7463b52174Bcb8decd352F5A055C76df6e808A13',
      25: '',
    },
    token: serializedTokens.muffin,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: true,
  },
  {
    pid: 15,
    lpSymbol: 'GINGER-USDC LP',
    lpAddresses: {
      338: '0xf13C07a34327715F0FE4dc824e1C1B3D86785F26',
      25: '',
    },
    token: serializedTokens.ginger,
    quoteToken: serializedTokens.usdc,
    version: 1,
    // startFrom: "2022-04-26T02:59:59+00:00"
  },
  {
    pid: 17,
    lpSymbol: 'VVS-START LP',
    lpAddresses: {
      338: '0x2030bBf39537bb629E9D849Bf2478C958745fb6b',
      25: '',
    },
    token: serializedTokens.start,
    quoteToken: serializedTokens.vvs,
    version: 2,
  },
  {
    pid: 18,
    lpSymbol: 'VVS-START1 LP',
    lpAddresses: {
      338: '0xa46dA4Fb44D6586f4E9d128eF29C763698E15152',
      25: '',
    },
    token: serializedTokens.start1,
    quoteToken: serializedTokens.vvs,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '0x1cDC9978937ee248DC1D7CF1f1bF7225200eEf22',
          25: '',
        },
        token: serializedTokens.start1,
      },
    ],
  },
  {
    pid: 19,
    lpSymbol: 'VVS-START2 LP',
    lpAddresses: {
      338: '0x0b001d4f0df9a75B6c19ca761538ACc7ed4dBfeA',
      25: '',
    },
    token: serializedTokens.start2,
    quoteToken: serializedTokens.vvs,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '0x1cDC9978937ee248DC1D7CF1f1bF7225200eEf22',
          25: '',
        },
        token: serializedTokens.start1,
      },
      {
        address: {
          338: '0x95114BC2d515d1EE9bA60c7eF54De0d3aA047e2D',
          25: '',
        },
        token: serializedTokens.start2,
      },
    ],
  },
  {
    pid: 20,
    lpSymbol: 'VVS-ROSE LP',
    lpAddresses: {
      338: '0x71F67b48B4C7BFde2415a1cEa48A06518FFA8Fcc',
      25: '',
    },
    token: serializedTokens.rose,
    quoteToken: serializedTokens.vvs,
    version: 2,
  },
  {
    pid: 21,
    lpSymbol: 'VVS-ROSE1 LP',
    lpAddresses: {
      338: '0xa42ea26d9f9b9927001A42A7B5869c2486Db9607',
      25: '',
    },
    token: serializedTokens.rose1,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x67c1326Da97dD0f14fAa1e5e0208Fb3FDfabc6Ae',
          25: '',
        },
        token: serializedTokens.rose1,
      },
      {
        address: {
          338: '0x95114BC2d515d1EE9bA60c7eF54De0d3aA047e2D',
          25: '',
        },
        token: serializedTokens.start2,
      },
    ],
  },
  {
    pid: 22,
    lpSymbol: 'VVS-ROSE2 LP',
    lpAddresses: {
      338: '0x37D4E1f3041310edA54f7937e97366aA96eBEE9c',
      25: '',
    },
    token: serializedTokens.rose2,
    quoteToken: serializedTokens.vvs,
    version: 2,
    multiYieldLabel: true,
    rewarders: [
      {
        address: {
          338: '0xe36BD0FB72fa70eF5057D7b323b164fB3EF15C60',
          25: '',
        },
        token: serializedTokens.rose2,
      },
      {
        address: {
          338: '0x1cDC9978937ee248DC1D7CF1f1bF7225200eEf22',
          25: '',
        },
        token: serializedTokens.start1,
      },
    ],
  },
  {
    pid: 23,
    lpSymbol: 'CRO-START1 LP',
    lpAddresses: {
      338: '0x321E3a6AEA4723e164f3b223aa50cfBDa5146EBb',
      25: '',
    },
    token: serializedTokens.start1,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x1cDC9978937ee248DC1D7CF1f1bF7225200eEf22',
          25: '',
        },
        token: serializedTokens.start1,
      },
      {
        address: {
          338: '0x800fd2B53F67b939344AD907F41423A93cDddbc0',
          25: '',
        },
        token: serializedTokens.usdc,
      },
    ],
  },
]

const farms: SerializedFarmConfig[] =
  process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString() ? mainnetFarms : testnetFarms

export default farms
